<template>
    <div id="recoverpassword">

         <v-dialog
      v-model="dialog"
      width="450"
    >
      <template v-slot:activator="{ on }">
        <v-btn
          
          class="text-none recoverpassword"
          color="white"
          flat
          dark
          v-on="on"
        >
          ¿Olvidaste tu contraseña? 
        </v-btn>
      </template>

      
      <v-card style="border-radius:10px" class="pb-5">
        <v-card-actions>
          <v-spacer></v-spacer>
        <v-btn  fab flat color="#B4347E" small @click="dialog = false">
          <v-icon x-large>cancel</v-icon>
        <!--<p style="font-family:Fredoka one; font-size:2.6vw">X</p>-->
        <!--<v-icon dark x-large>close</v-icon>-->
    </v-btn>
        </v-card-actions>
        
        <v-card-title 
          class="headline white lighten-2 justify-center"
          primary-title
          style="color:#528AC3;font-family:Poppins!important;font-size:1vw;font-weight:500"
        >
          Recupera tu cuenta
          
        </v-card-title>
        <v-card-title class="justify-center">
          <span class="ingresacorreo" >Ingresa tu correo, para poder ingresar una nueva contraseña</span>
          <br>
        </v-card-title>
        
        <v-layout row justify-center>
         <v-flex
          xs10
          md10
          lg10
         
        >
          <v-text-field
           
            v-model="email"
            :rules="emailRules"
            label="usuario@gmail.com"
            required
            solo
            prepend-inner-icon="person"
            flat
            style="background-color:#ebf1f8; border-radius:8px;" 
            class="pa-1 correo"
          ></v-text-field>
        </v-flex>
        <v-flex xs2 md2 lg2>
          <v-icon large color="green" style="margin-top:20px">check_circle</v-icon>
        </v-flex>
        </v-layout>

        <br><br>
        <v-layout row wrap justify-center="">
        <!--<v-btn
          large
      
      color="#4ba96c"
      href="#/confirm_password"
      class="text-none"
      style="border-radius:7px; color:white; font-family:Poppins;font-weight:500; font-size:1.5vw"
    >
      Enviar
    </v-btn>-->
    
    <!-- ENVIAR -->
    <v-dialog
      v-model="dialog1"
      width="450"
    >
      <template v-slot:activator="{ on }">
        <v-btn
          large
          
          class="text-none enviarrecover"
          color="#4ba96c"
          @click="enviarmail()"
        >
          Enviar 
        </v-btn>
      </template>

      
      <v-card style="border-radius:10px" class="pb-5">
        <v-card-actions>
          <v-spacer></v-spacer>
        <v-btn  fab flat color="#B4347E" small @click="dialog1 = false">
          <v-icon x-large>cancel</v-icon>
        <!--<p style="font-family:Fredoka one; font-size:2.6vw">X</p>-->
        <!--<v-icon dark x-large>close</v-icon>-->
    </v-btn>
        </v-card-actions>
        
        

        <v-card-title 
          class="headline white lighten-2 justify-center"
          primary-title
          style="color:#528AC3;font-family:Poppins!important;font-size:1vw;font-weight:600"
        >
        <img src="icono_contrasenamail.png" width="250px">
          Revisa tu correo          
        </v-card-title>
        <v-card-title class="justify-center">
          <span class="revisacorreo" >{{message}}</span>
          <br>
        </v-card-title>

        <v-layout row wrap justify-center="">
        <!--<v-btn
          large
      
      color="#4ba96c"
      href="#/confirm_password"
      class="text-none"
      style="border-radius:7px; color:white; font-family:Poppins;font-weight:500; font-size:1.5vw"
    >
      Enviar
    </v-btn>-->
    </v-layout>
      </v-card>
      
    </v-dialog>
    </v-layout>
      </v-card>
      
    </v-dialog>
    </div>
</template>


<script>
export default {
    data(){
      return{
        dialog:false,
        dialog1:false,
        message:"",
        email: '',
        emailRules: [
          v => !!v || 'E-mail is required',
          v => /.+@.+/.test(v) || 'E-mail must be valid'
        ]
      }
    },
    methods: {
      enviarmail: function(){
        var email = this.email.trim();
          email = email.toLowerCase();            
          var patron=/^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,4})+$/ ;            
          if(this.email==""){
            this.message="El campo de email no puede estar vacio"
            this.dialog1=true
            this.dialog=false
          }else if(email.search(patron)!=0){
            this.message="No es una direccion de correo valida, debe introducir una direccion de correo valida"
            this.dialog1=true
            this.dialog=false
          }else if(email.search(patron)==0){
              this.$store.dispatch('recovery', {email})
              .then((value) =>
                {
                  if (value == 200) {
                        this.message="Se ha enviado un email a la direccion de correo: "+email 
                        this.dialog1=true
                        this.dialog=false 
                  }else if(value == 400){
                        this.message="El correo "+email+" no es un usuario existente"
                        this.dialog1=true
                        this.dialog=false
                  }else{
                        this.message="Hubo un problema al completar la solicitud intentelo de nuevo mas tarde";
                        this.dialog1=true
                        this.dialog=false
                  }
                  }
              ).catch(() =>
                  {
                    this.dialog1=true
                    this.dialog=false
                    this.message="Hubo un problema al completar la solicitud intentelo de nuevo mas tarde";
                  }
              )          
          }
      }
    }
}
</script>


<style>

@media (min-width: 1200px){
  .recoverpassword{
  font-family:Poppins;
  font-weight:500;
  font-size:1.2vw;
  }

  .correo{
    margin-left:65px!important;
  }
  .ingresacorreo{
    color:grey;
    text-align:center; 
    font-size:1.1vw;
  }

  .enviarrecover{
    border-radius:7px; 
    color:white!important; 
    font-family:Poppins;
    font-weight:500; 
    font-size:1.5vw;
  }
  .revisacorreo{
    color:grey;
    text-align:center; 
    font-size:1.1vw;
    font-weight:500;
  }

 }

 @media (min-width: 300px) and (max-width: 750px){
   .correo{
     margin-left: 30px!important;
   }
  .ingresacorreo{
    color:grey;
    text-align:center; 
    font-size:3.8vw;
  }
  .enviarrecover{
    border-radius:7px; 
    color:white!important; 
    font-family:Poppins;
    font-weight:500; 
    font-size:5vw;
  }
  .revisacorreo{
    color:grey;
    text-align:center; 
    font-size:5vw;
    font-weight:500;
  }

 }

 @media (min-width: 750px) and (max-width: 1100px){
   .correo{
     margin-left: 65px!important;
   }
  .ingresacorreo{
    color:grey;
    text-align:center; 
    font-size:2.4vw;
  }
  .enviarrecover{
    border-radius:7px; 
    color:white!important; 
    font-family:Poppins;
    font-weight:500; 
    font-size:3.2vw;
  }
  .revisacorreo{
    color:grey;
    text-align:center; 
    font-size:2.8vw;
    font-weight:500;
  }
 }

 



</style>
